import Image from 'next/image'
import { Col, Collapse, Container } from '@microfrontends/react-components'
import { Paragraph } from '../../../components/NumerologyV2/index.css'
import Title, { TitleSpecial } from '../../../components/NumerologyV2/Title'
import { About, AboutWrap } from '../Numerology.css'
import AppContext from '../../../context/AppContext'
import { useContext } from 'react'
import { EDevice } from '../../MainLayout'

export default function HistoryNumerology() {
	const { breakpoint } = useContext(AppContext)
	return (
		<AboutWrap>
			<Container>
				<About gutter={30}>
					<Col>
						{breakpoint !== EDevice.MOBILE ? (
							<div
								style={{
									marginLeft: 20,
									marginTop: -20,
									float: 'right'
								}}
							>
								<Image
									className='bg__pythago-lc'
									src={`${process.env.IMAGE_BASE_URL}/numerology/about-numerology-3.png`}
									alt='about numerology'
									width={411}
									height={190}
								/>
							</div>
						) : null}

						<Title
							title='Lịch sử hình thành
						nhân số học'
							marker='triangle'
							backgound='oval'
						/>

						<Collapse
							custom={{
								enable: true,
								numberOfLines: 4,
								viewMoreText: (isCollapse) =>
									isCollapse ? (
										<span>Xem thêm</span>
									) : (
										<span>Rút gọn</span>
									)
							}}
							collapse={true}
							header
							className='collapse'
						>
							<Paragraph>
								Ai Cập và Babylon được xem là cái nôi ra đời của
								Nhân số học nhưng phổ biến đến ngày nay phải kể
								đến là Nhân số học theo góc nhìn Pythagoras.
							</Paragraph>
							<Paragraph>
								Bàn về lịch sử của Nhân số học phải lùi về hàng
								ngàn năm trước công nguyên khi con người bắt đầu
								canh tác, gieo trồng. Ai Cập và Babylon được xem
								là cái nôi ra đời của Nhân số học nhưng phổ biến
								đến ngày nay phải kể đến là Nhân số học theo góc
								nhìn Pythagoras. Tính đến hiện tại, Pythagoras
								vẫn được nhắc đến là {`“cha đẻ"`} của bộ môn
								nghiên cứu này.
							</Paragraph>
							<Paragraph>
								Ở tuổi trung niên, Pythagoras mở trường học mà ở
								đây ông không dạy toán học cơ bản, ngược lại đào
								sâu vào thế giới của những con số và những
								nguyên tắc ẩn giấu bên trong. Ông tin rằng thế
								giới hiện tại đều thể hiện dưới dạng số học. Từ
								đó, ông bắt đầu nghiên cứu mối quan hệ tương
								quan giữa những con số.
							</Paragraph>
							<Paragraph style={{ marginBottom: 0 }}>
								Có thể Pythagoras không phải là người trực tiếp
								sáng tạo ra Nhân số học nhưng những nghiên cứu
								số học của ông đã trở thành nền tảng cho các nhà
								triết học đương thời tiếp tục mở rộng nghiên cứu
								và đúc kết thành Nhân số học.
							</Paragraph>
						</Collapse>
						{breakpoint === EDevice.MOBILE ? (
							<div>
								<Image
									className='bg__pythago-lc'
									src={`${process.env.IMAGE_BASE_URL}/numerology/about-numerology-3.png`}
									alt='about numerology'
									width={411 * 2}
									height={190 * 2}
								/>
							</div>
						) : null}
					</Col>
					<Col>
						{breakpoint !== EDevice.MOBILE ? (
							<div
								style={{
									marginRight: 20,
									float: 'left'
								}}
							>
								<Image
									className='bg__pythago-lc'
									src={`${process.env.IMAGE_BASE_URL}/numerology/about-numerology-4.png`}
									alt='about numerology'
									width={401}
									height={144}
								/>
							</div>
						) : null}

						<TitleSpecial
							title={`Ứng dụng nhân số học trong việc <br/> định hướng sự nghiệp`}
							marker='triangle'
							backgound='oval'
						/>

						<Collapse
							custom={{
								enable: true,
								numberOfLines: 2,
								viewMoreText: (isCollapse) =>
									isCollapse ? (
										<span>Xem thêm</span>
									) : (
										<span>Rút gọn</span>
									)
							}}
							collapse={true}
							header
							className='collapse'
						>
							<Paragraph>
								Mỗi người đều mong muốn có một công việc{' '}
								{`“đúng"`}, đúng ở đây là đúng với cái bạn giỏi,
								đúng với cái bạn muốn làm, đúng với những giá
								trị mà bạn theo đuổi.
							</Paragraph>
							<Paragraph>
								Khi tìm được công việc đúng với giá trị và sở
								trường của chính mình, nó có thể mang đến cho
								bạn niềm vui, tiền bạc và hạnh phúc trọn vẹn của
								một đời làm nghề. Nếu bạn lệch hướng trên hành
								trình sự nghiệp, ngoài việc lãng phí thời gian
								và công sức nó còn tác động đến tâm lý, làm mất
								đi động lực phát triển bản thân và kéo bạn trượt
								dài trên con đường sự nghiệp tương lai.
							</Paragraph>
							<Paragraph style={{ marginBottom: 0 }}>
								Nhân số học chính là công cụ tham khảo nhằm giúp
								bạn gợi ý nghề nghiệp phù hợp dựa trên những
								điểm mạnh và điểm yếu của những con số liên quan
								đến bạn. Dựa trên thông tin: Họ tên, ngày tháng
								năm sinh của bạn, Nhân số học sẽ phân tích và
								tạo lập cho bạn biểu đồ sự nghiệp hoàn chỉnh.
							</Paragraph>
						</Collapse>

						{breakpoint === EDevice.MOBILE ? (
							<div style={{ marginTop: 20 }}>
								<Image
									className='bg__pythago-lc'
									src={`${process.env.IMAGE_BASE_URL}/numerology/about-numerology-4.png`}
									alt='about numerology'
									width={401 * 2}
									height={144 * 2}
								/>
							</div>
						) : null}
					</Col>
				</About>
			</Container>
		</AboutWrap>
	)
}
